export default __webpack_public_path__ + "static/media/search.48711401.svg";